module.exports = __webpack_public_path__ + "static/media/Contact.3d64ef58.svg";